import { useEffect, useState } from "react";

/** Tailwind's `lg` (1024px): the sidebar is shown and side panels fit beside lists. */
export const LG_QUERY = "(min-width: 1024px)";

/** Live `matchMedia` result — for layouts CSS alone can't switch (e.g. side panel vs modal). */
export function useMediaQuery(query: string): boolean {
  const get = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const list = window.matchMedia(query);
    const onChange = () => setMatches(list.matches);
    onChange();
    list.addEventListener?.("change", onChange);
    return () => list.removeEventListener?.("change", onChange);
  }, [query]);

  return matches;
}
